<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="team-members h-100">
        <div class="header row">
            <h4 class="invisible">Members</h4>
        </div>
        <div class="team-info-tab-row row nav-pills d-flex">
            <a class="nav-link" href="#" v-on:click="$parent.showTeamProjects">Projects</a>
            <a class="nav-link active" href="#">People</a>
            <div class="flex-fill d-flex justify-content-end">
                <button data-toggle="modal"
                        data-target="#modal-new-invite"
                        v-bind:class="{'hide': hasCard()}"
                        class="btn btn-attention btn-new-item pull-right btn-invite">
                    New Member
                </button>
            </div>
        </div>
        <div class="team-info-body row">
            <div class="w-100">
                <div v-if="_team" id="member-list" class="list-group">
                    <div v-for="p in participants"
                         class="list-group-item list-group-item-action"
                         v-bind="{'data-id': p.uid}">
                        <member-item
                                v-bind:member="p"
                                v-bind:team="_team"
                                removeButton>
                        </member-item>
                    </div>
                    <div v-for="c in candidates"
                         class="list-group-item list-group-item-action"
                         v-bind="{'data-id': c.email}">
                        <candidate-item
                                v-bind:candidate="c"
                                v-bind:team="_team"
                                @invite="setInvitationData(c)">
                        </candidate-item>
                    </div>
                    <div v-for="ivt in invites"
                         class="list-group-item"
                         v-bind="{'data-id': ivt.code}">
                        <invite-item
                                v-bind:invite="ivt"
                                v-bind:team="_team">
                        </invite-item>
                    </div>
                </div>
            </div>
            <div v-bind:class="{'d-none': !hasCard()}" class="w-100">
                <div class="justify-content-center">
                    <div class="text-center">
                        <i class="fa fa-5x fa-user-plus mt-5 mb-2"></i><br>
                        <button type="button"
                                class="btn btn-attention btn-new-item"
                                data-toggle="modal"
                                data-target="#modal-new-invite">
                            Invite New Member
                        </button>
                    </div>
                </div>
                <div class="mt-3 justify-content-center">
                    <p class="text-muted text-center">You can invite as many people as you wish. You are charged for active team members only.<br>
                        <a href="https://help.ganttproject.biz/t/what-is-a-team-in-ganttproject-cloud" target="_blank">Learn more</a></p>
                </div>
            </div>
        </div>
        <TeamInviteModal v-if="_team" :team="_team" :dashboard-refresh="onInviteCreated" ref="inviteModal">
        </TeamInviteModal>
    </div>
</template>

<style lang="scss">
    .hide {
      visibility: hidden;
    }
    .team-members {
      display: flex;
      flex-direction: column;
    }
    .team-info-body {
        overflow-y: auto;
    }
</style>

<script lang="ts">
import {Prop, Watch, Component, Vue} from 'vue-facing-decorator';
import {updateDependencies} from '../Dashboard';
import {InviteDto, loadTeam, ParticipantDto, ResourceDto, TeamDto} from '../Teams';
import {SelectionModel} from '../utils/Ui';
import TeamInviteModal from './TeamInviteModal.vue';

import $ from 'jquery';

@Component({
  components: {TeamInviteModal},
})
export default class TeamMembers extends Vue {
  private _team?: TeamDto = null;

  private invites: List<InviteDto> = [];
  private participants: List<ParticipantDto> = [];
  private candidates: List<ResourceDto> = [];
  private selectionModel = new SelectionModel<ParticipantDto | InviteDto | ResourceDto>(
      '#member-list',
      '.list-group-item',
      'data-id',
      (a, b) => a.email === b.email,
  );
  private afterUpdates: MutableList<JQueryDeferred<any>> = [];

  public $refs!: {
    inviteModal: TeamInviteModal,
  };

  public mounted() {
    $(this.$el).on('shown.bs.modal', () => $('#modal-new-invite-name').focus());
  }

  public updated() {
    this.$nextTick(() => {
      this.afterUpdates.map((deferred) => deferred.resolve());
      this.afterUpdates = [];
    });
  }

  public hasCard(): boolean {
    return this.participants.length + this.invites.length + this.candidates.length <= 1;
  }

  public onInviteCreated() {
    loadTeam(this._team!!.refid).then(updateDependencies);
  }

  public setTeam(val: TeamDto | null) {
    if (!val) {
      this.participants = [];
      this.candidates = [];
      this.invites = [];
      return;
    }

    this._team = val;
    this.participants = val.participants;
    this.candidates = val.resources
    this.invites = val.invites ? val.invites : [];
    const id2model = (id) => {
      return this.participants.find((p) => p.uid === id)
          || this.invites.find((ivt) => ivt.code === id)
          || this.candidates.find((c) => c.email === id);
    };
    this.afterUpdates.push(this.selectionModel.init(id2model, (_) => {}));
  }

  private setInvitationData(candidate: ResourceDto) {
    this.$refs.inviteModal.inviteName = candidate.name;
    this.$refs.inviteModal.inviteEmail = candidate.email;
  }
}
</script>
